import { format } from "date-fns";
import moment from "moment";

export const convertDateToString = (date: Date): string => {
	return format(date, "yyyy-MM-dd HH:mm");
};

export const convertMomentDateToString = (date: moment.Moment): string => {
	return date.format("DD MMM YY h:mm A");
};

export const convertDateToStringForCoupon = (date: Date): string => {
	return format(date, "yyyy-MM-dd HH:mm");
};

export const parseISOformat = (datetime: string | Date): string => {
	return moment(datetime).format("DD/MM/YYYY hh:mm A");
};

/**
	 *                      +-------------+
							|    Server   |
							+-------------+
								|
								| sends date in ISO format
								V
							+----------------+
							|  Input Parser  |
							+----------------+
								|
								| converts ISO format to date object
								V
							+----------------+
							|  Formatter     |
							+----------------+
								|
								| formats date object as per component requirement
								V
							+----------------+
							|  Components    |
							+----------------+


	*/
